import { NavLink, useLocation, useNavigate } from 'react-router';
import { Plus, Settings as SettingsIcon, Sparkles } from 'lucide-react';
import { cn } from '@dd/ui';
import { useT } from '@/lib/i18n';
import { Logo } from './Logo';
import { useShop } from '@/hooks/useShop';
import { useNavModel } from './BottomNav';

/** Laptop / desktop (≥ 1024 px): the bottom bar becomes a left menu so the screen is used properly instead of a phone strip in the middle. */
export function SideNav() {
  const { items, fab } = useNavModel();
  const { t } = useT();
  const nav = useNavigate();
  const loc = useLocation();
  const shop = useShop();
  return (
    <aside aria-label={t('প্রধান মেনু', 'Main menu')} className="fixed inset-y-0 left-0 z-40 hidden w-64 flex-col border-r border-line bg-white px-4 py-5 lg:flex">
      <div className="flex h-10 items-center px-2"><Logo size={38} withText /></div>
      <button type="button" onClick={() => nav(fab.to, { state: { from: loc.pathname } })} className="mt-6 flex items-center justify-center gap-2 rounded-2xl bg-brand px-4 py-3 text-[15px] font-bold text-white shadow-card transition hover:bg-brand-dark active:scale-[0.98]">
        <Plus size={20} strokeWidth={2.6} />{fab.label}
      </button>
      <nav className="mt-6 flex flex-1 flex-col gap-1">
        {items.map(({ to, Icon, label, end, active }) => (
          <NavLink key={to} to={to} end={end} className={({ isActive }) => cn('flex items-center gap-3 rounded-xl px-3 py-2.5 text-[15px] font-semibold transition-colors', (active ?? isActive) ? 'bg-brand-light text-brand-dark' : 'text-ink-2 hover:bg-neutral-50')}>
            <Icon size={20} strokeWidth={2.2} />{label}
          </NavLink>
        ))}
        <div className="my-2 border-t border-line" />
        {shop.kind !== 'personal' && <NavLink to="/assistant" className={({ isActive }) => cn('flex items-center gap-3 rounded-xl px-3 py-2.5 text-[15px] font-semibold', isActive ? 'bg-brand-light text-brand-dark' : 'text-ink-2 hover:bg-neutral-50')}><Sparkles size={20} />DukanIQ</NavLink>}
        <NavLink to="/settings" className={({ isActive }) => cn('flex items-center gap-3 rounded-xl px-3 py-2.5 text-[15px] font-semibold', isActive ? 'bg-brand-light text-brand-dark' : 'text-ink-2 hover:bg-neutral-50')}><SettingsIcon size={20} />{t('সেটিংস', 'Settings')}</NavLink>
      </nav>
      <p className="px-2 text-[11px] leading-snug text-ink-3">DokaanDigit · NTechEdge</p>
    </aside>
  );
}
